import React, { useState } from "react";
import MainLayout from "../../layout/mainLayout";
import { Row, Col, Form } from "react-bootstrap";
import "./index.scss";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  formatAmount,
  getCodeFromUrl,
  getParamsFromURL,
  modifyEncodedURLParams,
  renderOrderStatus,
  renderStatus,
  setParamsInURL,
  setRedirectParams,
} from "../../utils/helper";
import dateFormat from "dateformat";
import { useLocation, useNavigate } from "react-router-dom";
import Checkbox from "../../components/common/FormFields/checkbox";
import { useForm } from "react-hook-form";
import { getProductListing, readData } from "../../service/order/orderService";
import { openModal, setSelectValidError } from "../../store/slices/commonSlice";
import {
  paymentDetails,
  summaryMap,
} from "../../service/proposal/proposalService";
import Button from "../../components/common/button";
import LegalDocument from "../../components/legalDocumentModal";
import { buyNow, ordersDetails } from "../../utils/router/constant";
import Loader from "../../components/common/loader";
import { api_strapi } from "../../utils/interface";
import RMCard from "../../components/rmCard";
import OrderRestrictionModal from "../../components/common/OrderRestrictionModal";

const PaymentSummary = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [orderId, setOrderId] = useState(null);
  const [show, setShow] = useState(false);
  const [documentData, setDocumentData] = useState([]);
  const codeFromUrl = getCodeFromUrl();
  const detailsData = useSelector(
    (state) => state.orders.selectedOrder.detailsData,
  );
  const productData = useSelector(
    (state) => state.orders.selectedOrder.productData,
  );
  const formState = useSelector((state) => state.common.formRendererState);
  const summaryDetails = useSelector((state) => state.buyNow.summaryDetails);

  const nav = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showRestrictionModal, setShowRestrictionModal] = useState(false);
  const [restrictionError, setRestrictionError] = useState(null);

  const {
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
  });
  const closeModal = () => {
    setShow(false);
  };
  useEffect(() => {
    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          setOrderId(params["orderId"]);
        } else {
          console.error("No parameters found");
        }
      });
    };
    fetchCode();
  }, [location]);

  useEffect(() => {
    if (orderId) {
      readData(orderId, "ODR");
      summaryMap(orderId);
      getProductListing(orderId);
    }
  }, [orderId]);

  useEffect(() => {
    const redirectWithCode = async () => {
      if (detailsData?.redirect_url) {
        let redirectUrlWithParams = `${detailsData.redirect_url}`;
        if (window.location.href !== redirectUrlWithParams) {
          const token = localStorage.getItem("token");
          if (token) {
            redirectUrlWithParams = await modifyEncodedURLParams(
              detailsData.redirect_url,
              "token",
              "add",
              token,
            );
          }
          // window.location.href = redirectUrlWithParams;
          window.location.replace(redirectUrlWithParams);
        }
      }
    };

    redirectWithCode();
  }, [detailsData?.redirect_url, location]);

  const handlePreviousBtn = async () => {
    const paramObject = {
      entityid: detailsData.product_id,
      orderId: orderId,
    };
    const params = await setParamsInURL(location, paramObject);
    nav(`${buyNow}?${params}`);
  };

  const handleFinish = async (e) => {
    e.preventDefault();
    if (formState) {
      dispatch(setSelectValidError(false));
      setLoader(true);
      try {
        await paymentDetails(orderId, "PMT", "ODR");
        setLoader(false);
      } catch (error) {
        console.error("Payment details error:", error);
        setLoader(false);
        const errorCode = error?.response?.data?.error_code;
        if (errorCode === "ERR_029" || errorCode === "ERR_030") {
          setRestrictionError(error?.response?.data);
          setShowRestrictionModal(true);
        }
      }
    } else {
      dispatch(setSelectValidError(true));
    }
  };


  const OpenModal = (value) => {
    const getDocument = async () => {
      try {
        const response = await api_strapi.get(
          `/terms-and-conditions?filters[slug][$eq]=${`${value}-${codeFromUrl}`}&populate=termsAndCondition`,
        );

        if (response.status === 200 && response) {
          setDocumentData(response?.data?.data[0]?.attributes);
        }
      } catch (error) {
        console.error("error fetching document", error);
      }
    };
    getDocument();

    setShow(true);
  };

  const getCoverValue = (orderData) => {
    let cover = 0;
    if (orderData && orderData?.variant_json) {
      const data = JSON.parse(orderData?.variant_json);
      productData.map((proData) => {
        let id = proData?.entityid;
        cover = data[id]?.cover;
        return formatAmount(cover);
      });
    }
    return formatAmount(cover);
  };

  const productType = detailsData.product_type_name;

  return (
    <MainLayout>
      <div className="pay-summary-container">
        <div className="order-info">
          <div className="order-header">
            <div className="order-id">Order ID : {detailsData.code}</div>
            <div className="order-status">
              {renderStatus(detailsData.status)}
            </div>
          </div>
          <div className="order-date">
            Order Date :{" "}
            {detailsData.created_date
              ? dateFormat(detailsData.created_date, "dd mmm yyyy")
              : "-"}
          </div>
        </div>

        <Form onSubmit={handleFinish}>
          <Row>
            <Col xs="12" lg={9}>
              <div className="product-container">
                <div className="product-card">
                  <div className="card--img ">
                    {productType === "UMBRELLA" ? (
                      // <img src={productData[0]?.oem_media_url} alt="Insurance" />
                      <>
                        {summaryDetails.oems?.map((variant, index) => (
                          <img
                            key={index}
                            src={variant.media_url}
                            alt="Insurance"
                          />
                        ))}
                      </>
                    ) : (
                      <img
                        src={detailsData?.product_logo_url}
                        alt="Insurance"
                      />
                    )}
                  </div>
                  <div className="product-details">
                    <div className="product-name">{detailsData.name}</div>
                  </div>
                  {productType !== "UMBRELLA" ? (
                    <>
                      <div className="product-details-summary">
                        <div className="product-label-cover">Cover</div>
                        <div className="product-value-cover">
                          {getCoverValue(detailsData)}
                        </div>
                      </div>
                      {/* <div className="product-details-summary">
                      <div className="product-label-premium">Premium</div>
                      <div className="product-value-premium">
                        {formatAmount(detailsData.gross_amount)}
                      </div>
                    </div> */}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="product-container">
                <div className="summary-card">
                  <div className="header-container">
                    <Row>
                      <Col
                        className={`${productType === "UMBRELLA" ? "col-md-10" : "col-md-12"
                          }`}
                      >
                        <div className="summary-title">Order Summary</div>
                        <div className="premium-details">Premium Breakup</div>
                      </Col>
                      {productType === "UMBRELLA" ? (
                        <>
                          <Col className="cover-label col-md-1">Cover</Col>
                          <Col className="cover-label col-md-1">Premium</Col>
                        </>
                      ) : (
                        <></>
                      )}
                    </Row>
                  </div>
                  <hr className="divider" />
                  {productData.map((product, index) => {
                    const productDetails =
                      summaryDetails?.[product?.entityid] || {};
                    return (
                      <Row>
                        <Col
                          className={`summary-price ${productType === "UMBRELLA"
                              ? "col-md-10"
                              : "col-md-11"
                            } `}
                        >
                          <div className="summary-content">
                            {/* <div className="card--img">
                            <img
                              src={product.oem_media_url || "default-image.png"}
                              alt={product.name || "Insurance"}
                            />
                          </div> */}
                            <div className="summary-details">
                              <div className="summary-name">{product.name}</div>
                              {productType !== "UMBRELLA" ? (
                                <div className="summary-description">
                                  {product.oem_name || "N/A"}
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </Col>
                        {productType === "UMBRELLA" ? (
                          <>
                            <Col className="text-end col-md-1">
                              <div className="summary-price">
                                {productDetails.cover
                                  ? formatAmount(productDetails.cover.value)
                                  : "N/A"}
                              </div>
                            </Col>
                          </>
                        ) : (
                          <></>
                        )}

                        <Col className="text-end col-md-1">
                          <div className="summary-price">
                            {productDetails.premium
                              ? formatAmount(productDetails.premium.value)
                              : "N/A"}
                          </div>
                        </Col>
                      </Row>
                    );
                  })}
                  <hr />
                  <div className="summary-total-premium">
                    <div className="summary-details">
                      <div className="summary-cost">Total Base Premium</div>
                      <div className="summary-cost">
                        {formatAmount(summaryDetails.base)}
                      </div>
                    </div>
                    <div className="summary-details">
                      <div className="summary-cost">GST</div>
                      <div className="summary-cost">
                        {formatAmount(summaryDetails.tax)}
                      </div>
                    </div>
                    <div className="summary-details total-premium">
                      <div className="summary-cost total-label">Total Premium Amount</div>
                      <div className="summary-cost total-value">
                        {formatAmount(summaryDetails.total)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="product-container summary-card">
                <Checkbox
                  rules={{
                    required: true,
                  }}
                  name="statement"
                  className="checkbox-style"
                  control={control}
                  errors={errors}
                  options={[
                    {
                      name: "statement",
                      label:
                        "I/We hereby declare that the above statement and particulars are true and I/we have not suppressed or misstated any material facts and that at the present time I/we have no reason to anticipate any claim being brought against me/us for any negligent act, error or omission on my/our part and agree that this declaration shall be the basis of the contract between me/us and the Insurer. I/we also agree that the indemnity under the insurance shall not be availed for claims arising out of acts of negligence, error or omission or misconduct committed PRIOR to commencement of this insurance",
                    },
                  ]}
                />
                <Checkbox
                  rules={{
                    required: true,
                  }}
                  name="policy"
                  className="checkbox-style"
                  control={control}
                  errors={errors}
                  options={[
                    {
                      name: "policy",
                      label: (
                        <>
                          I have read the{" "}
                          <span
                            target="_blank"
                            rel="noopener noreferrer"
                            className="link-style"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              OpenModal("cancellation-and-refund");
                            }}
                            style={{ cursor: "pointer", color: "blue" }}
                          >
                            Cancellation & Refund
                          </span>{" "}
                          policy
                        </>
                      ),
                      checked: false,
                    },
                  ]}
                />
              </div>
            </Col>
            <Col xs="12" lg={3}>
              <RMCard />
            </Col>
          </Row>
          <div className="button-container">
            <div className="summary-bottom">
              {productType !== "UMBRELLA" && (
                <Button
                  type="button"
                  variant="primary"
                  className="previous"
                  onClick={() => handlePreviousBtn()}
                  // disabled={!isValid}
                  label="Previous"
                />
              )}
              {(detailsData.status === "PAYMENT_PENDING" ||
                detailsData.status === "PAYMENT_FAILED") && (
                  <Button
                    type="submit"
                    variant="primary"
                    className="pay"
                    // disabled={!isValid}
                    disabled={loader}
                    label={
                      loader ? (
                        <Loader
                          className="pay-loader"
                          color={"white"}
                          height={25}
                          width={20}
                        />
                      ) : (
                        `Pay ${formatAmount(
                          detailsData.gross_amount,
                          null,
                          null,
                          null,
                        )}`
                      )
                    }
                  />
                )}
            </div>
          </div>
        </Form>
      </div>

      <LegalDocument
        documentData={documentData}
        setShow={openModal}
        show={show}
        closeModal={closeModal}
      />
      <OrderRestrictionModal
        show={showRestrictionModal}
        onHide={() => setShowRestrictionModal(false)}
        errorData={restrictionError}
        entityid={detailsData?.product_id}
        orderId={orderId}
        productName={detailsData?.name}
      />
    </MainLayout>
  );
};

export default PaymentSummary;
